import {
  REQUEST_MAP_PARKING_POSITIONS,
  RESPONSE_MAP_PARKING_POSITIONS,
  REQUEST_MAP_PARKING_POSITIONS_FAILURE,
  CLEAR_MAP_PARKING_POSITIONS,
} from "../actions/mapParkingPositionsActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  parkingsCount: 0,
  parkings: [],
};

const mapPositionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MAP_PARKING_POSITIONS:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    case RESPONSE_MAP_PARKING_POSITIONS:
      const { parkings, count } = action.payload;

      return Object.assign({}, state, {
        dataState: states.READY,
        parkings: parkings,
        parkingsCount: count,
        errors: [],
      });
    case REQUEST_MAP_PARKING_POSITIONS_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });
    case CLEAR_MAP_PARKING_POSITIONS:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

export default mapPositionsReducer;
